<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import { barChart } from "./data-overview";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Postagem",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader },
  data() {
    return {
      updating: true,
      barChart: barChart,
      title: "Detalhes Postagem",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Detalhes Postagem",
          active: true
        }
      ]
    };
  },
  mounted() {
    console.log('mounted postagem-detalhe_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <img src="@/assets/images/companies/insta_logo.png" alt class="avatar-sm me-4" />

              <div class="flex-grow-1 overflow-hidden">
                <h5 class="text-truncate font-size-15">Prospecção Produto Testes 000888</h5>
                <p class="text-muted">Companha para alavancar lançamento de produto.</p>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">Detalhes do postagem:</h5>

            <p
                class="text-muted"
            >Diferenciais de uso do produto</p>

            <div class="text-muted mt-4">
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> O melhor custo benefício
              </p>
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> Os melhores recursos
              </p>
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> Diferenciais
              </p>
            </div>

            <div class="row task-dates">
              <div class="col-sm-4 col-6">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar me-1 text-primary"></i> Início
                  </h5>
                  <p class="text-muted mb-0">15 Set, 2023</p>
                </div>
              </div>

              <div class="col-sm-4 col-6">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar-check me-1 text-primary"></i> Última Interação
                  </h5>
                  <p class="text-muted mb-0">15 Set, 2023</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->


      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
<!--            <h4 class="card-title mb-4">Membros de Equipe</h4>-->
            <div class="text-center">
              <img src="@/assets/images/users/post-cliente.png" class="img-fluid" alt="Responsive image" style="max-height: 330px;"/>
            </div>



          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row" v-if="!updating">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Resumo das Interações</h4>

            <div id="overview-chart" class="apex-charts" dir="ltr"></div>
            <apexchart
                class="apex-charts"
                type="bar"
                height="280"
                :series="barChart.series"
                :options="barChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Material de Apoio</h4>
            <div class="table-responsive">
              <table class="table table-nowrap table-centered table-hover mb-0 align-middle">
                <tbody>
                <tr>
                  <td style="width: 45px;">
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">
                      <a href="javascript: void(0);" class="text-dark">Imagens_compactadas.zip</a>
                    </h5>
                    <small>Tamanho: 3.25 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">
                      <a href="javascript: void(0);" class="text-dark">Vídeo_capacitação_plataforma.zip</a>
                    </h5>
                    <small>Tamanho: 3.15 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">
                      <a href="javascript: void(0);" class="text-dark">Logomarca.zip</a>
                    </h5>
                    <small>Tamanho: 2.02 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="avatar-sm">
                        <span
                            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-24"
                        >
                          <i class="bx bxs-file-doc"></i>
                        </span>
                    </div>
                  </td>
                  <td>
                    <h5 class="font-size-14">
                      <a href="javascript: void(0);" class="text-dark">Campanha_produto_0099.zip</a>
                    </h5>
                    <small>Tamanho: 2.25 MB</small>
                  </td>
                  <td>
                    <div class="text-center">
                      <a href="javascript: void(0);" class="text-dark">
                        <i class="bx bx-download h3 m-0"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Interações</h4>

            <div class="d-flex mb-4">
              <div class="me-3">
                <img
                    class="media-object rounded-circle avatar-xs"
                    alt
                    src="@/assets/images/users/avatar-2.jpg"
                />
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">Daniel Silva</h5>
                <p class="text-muted mb-1">Conclusão de validação regras comerciais.</p>
              </div>
              <div class="ms-3">
                <a href class="text-primary">Responder</a>
              </div>
            </div>

            <div class="d-flex mb-4">
              <div class="me-3">
                <img
                    class="media-object rounded-circle avatar-xs"
                    alt
                    src="@/assets/images/users/avatar-3.jpg"
                />
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">Carlos Souza</h5>
                <p class="text-muted mb-1">
                  <a href class="text-success">@Daniel</a>
                  Favor observar nova regra comercial alimentada no ERP
                </p>
                <div class="d-flex mt-3">
                  <div class="avatar-xs me-3">
                    <span
                        class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
                    >J</span>
                  </div>
                  <div class="flex-grow-1">
                    <h5 class="font-size-13 mb-1">José da Silva</h5>
                    <p class="text-muted mb-1">tratado e validado</p>
                  </div>
                  <div class="ms-3">
                    <a href class="text-primary">Responder</a>
                  </div>
                </div>
              </div>
              <div class="ms-3">
                <a href class="text-primary">Responder</a>
              </div>
            </div>

            <div class="d-flex mb-4">
              <div class="avatar-xs me-3">
                <span
                    class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-16"
                >J</span>
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-13 mb-1">José da Silva</h5>
                <p class="text-muted mb-1">Novos filtros de gerentes disponíveis.</p>
              </div>
              <div class="ms-3">
                <a href class="text-primary">Responder</a>
              </div>
            </div>

            <div class="text-center mt-4 pt-2">
              <a href="javascript: void(0);" class="btn btn-primary btn-sm">Mais detalhes</a>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>